import _sfc_main from "./AudioControl.vue2.mjs";
/* empty css                   */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", [_c(_setup.AudioMediaControl, { attrs: { "has-more": _setup.hasMore, "is-muted": !_setup.localUser.hasAudioStream, "is-disabled": _setup.isLocalAudioIconDisable, "audio-volume": _setup.userVolumeObj[_setup.localUser.userId] }, on: { "click": _setup.handleAudioMediaClick } }), _c(_setup.Dialog, { attrs: { "title": _setup.t("Tips"), "modal": true, "show-close": false, "close-on-click-modal": false, "width": "500px", "append-to-room-container": true, "confirm-button": _setup.t("Turn on the microphone"), "cancel-button": _setup.t("Keep it closed") }, on: { "confirm": _setup.handleAccept, "cancel": _setup.handleReject }, scopedSlots: _vm._u([{ key: "footer", fn: function() {
    return [_c(_setup.TuiButton, { staticClass: "agree-button", attrs: { "size": "default" }, on: { "click": _setup.handleAccept } }, [_vm._v(" " + _vm._s(_setup.t("Turn on the microphone")) + " ")]), _c(_setup.TuiButton, { staticClass: "cancel-button", attrs: { "size": "default", "type": "primary" }, on: { "click": _setup.handleReject } }, [_vm._v(" " + _vm._s(_setup.t("Keep it closed")) + " ")])];
  }, proxy: true }]), model: { value: _setup.showRequestOpenMicDialog, callback: function($$v) {
    _setup.showRequestOpenMicDialog = $$v;
  }, expression: "showRequestOpenMicDialog" } }, [_c("span", [_vm._v(_vm._s(_setup.dialogContent))])])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "1eff5ae4"
);
const AudioControl = __component__.exports;
export {
  AudioControl as default
};
